let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8kDgw")).then(() => parcelRequire('ai6mL'));